export { default as updateTemplate } from './updateTemplate';
export { default as updateNavigation } from './updateNavigation';
export { default as objectfyArray } from './objectfyArray';
export { mapDefaultLinksToLinks as mapDefaultLinksToLinks } from './mapDefaultLinksToLinks';